export const WIDGET_NAME = "verigor-answer-renderer";

export const DATE_MODEL = () => {
  return "DD.MM.YYYY";
};

export const TIME_MODEL = () => {
  return "HH:mm";
};

export const IMAGE_STORE_BASE_URL =
  "https://dev-information-retrieval-store.s3.us-west-2.amazonaws.com/data_insight_images";

export const MIXED_RENDER_MAX_DEPTH = 5;

export const SUGGESTION_CLICK_EVENT = "suggestionclick";

export const INVALID_VALUE_MESSAGE = "Geçersiz cevap verisi.";

export const PROCESS_ERROR_MESSAGE = "Cevap render edilemedi.";

export const STILL_WORKING_MESSAGE = "Cevabın devamı hazırlanıyor...";

export const WORKER_STEP_LABELS: Record<string, string> = {
  standalone: "Soruyu netleştiriyorum...",
  is_redundant: "Sorunun tekrar olup olmadığını kontrol ediyorum...",
  search_best_match: "İlgili verileri arıyorum...",
  file_selection: "Dosyaları seçiyorum...",
  subquery_generation: "Alt soruları hazırlıyorum...",
  prepare_code: "Sorguyu çalıştırmak için kod hazırlıyorum...",
  execute_python_script: "Sorguyu çalıştırıyorum...",
  correct_code: "Kodu düzeltiyorum...",
  code_explanation: "Sonucu açıklıyorum...",
  narrative_generation: "Anlatımı hazırlıyorum...",
};
